/* eslint-disable consistent-return */
import React, { ChangeEvent, useRef, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { UploadArrow } from "../../../../components/Icons";
import {
    StyledUploadBtn,
    StyledUploadDiv,
    StyledUploadInfo,
    StyledUploadSpan,
    StyledUploadTitle,
    StyledUploadWarning,
} from "../../../../styles/pages/AdministratorTach/ModalInformation";
import AdminTachService from "../../../../service/Docente/AdminTachService";
import GenericUtils from "../../../../utils/GenericUtils";
import ModalStatusInformation from "./ModalStatusInformation";

interface IUploadInformation {
    setFileName: (arg0: string) => void;
    subprocessId: string;
}

const UploadInformation: React.FC<IUploadInformation> = ({
    setFileName,
    subprocessId,
}) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [textFile, setTextFile] = useState("Nenhum arquivo selecionado");
    const [isLoadingUpload, setIsLoadingUpload] = useState<boolean>(false);
    const [success, setSuccess] = useState(false);
    const [showStatusInfo, setShowStatusInfo] = useState(false);

    const { instance } = useMsal();

    const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
        setIsLoadingUpload(true);
        setFileName("");

        const file = event.target.files && event.target.files[0];

        if (file) {
            const allowedExtensions = [".pdf", ".xlsx", ".docx", ".zip"];
            const newFileName = file.name.toLowerCase();
            const fileExtension = newFileName.substring(
                newFileName.lastIndexOf(".")
            );

            if (allowedExtensions.includes(fileExtension)) {
                const response = await AdminTachService.getSubprocessUploadLink(
                    subprocessId,
                    newFileName,
                    instance
                );

                if (
                    GenericUtils.isSuccessStatus(response) &&
                    response.data &&
                    response.data?.link.length
                ) {
                    const responseUpload =
                        await AdminTachService.uploadFileByUrl(
                            response.data?.link,
                            file
                        );

                    if (GenericUtils.isSuccessStatus(responseUpload)) {
                        setFileName(response.data?.fileName);
                        setTextFile(`Arquivo selecionado: ${file.name}`);
                        setSuccess(true);
                    } else {
                        setSuccess(false);
                    }
                } else {
                    setSuccess(false);
                }
            } else {
                setTextFile("Nenhum arquivo selecionado");
                setSuccess(false);
            }

            setShowStatusInfo(true);
            setIsLoadingUpload(false);
        }
    };

    const handleSelectFileClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const statusInformation = <ModalStatusInformation success={success} />;

    return (
        <StyledUploadDiv>
            <StyledUploadTitle>Anexe seu arquivo</StyledUploadTitle>
            <StyledUploadInfo>
                Você pode anexar arquivos nos formatos .pdf, .xlsx, .docx e .zip
            </StyledUploadInfo>
            <StyledUploadBtn
                type="button"
                onClick={handleSelectFileClick}
                disabled={isLoadingUpload}
            >
                <UploadArrow />
                Selecionar arquivo
            </StyledUploadBtn>
            <input
                ref={fileInputRef}
                id="fileInput"
                type="file"
                style={{ display: "none" }}
                onChange={handleFileChange}
                data-testid="file-input"
            />
            <StyledUploadSpan>{textFile}</StyledUploadSpan>
            <StyledUploadWarning>
                É permitido o upload de um único arquivo por vez.
            </StyledUploadWarning>
            {showStatusInfo && statusInformation}
        </StyledUploadDiv>
    );
};

export default UploadInformation;
